<template>
    <v-container fluid id="pricing">
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header color="accent" class="text-customizer-accent">
                    {{ $t("page.events.pricing.event-taxes") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <br />
                    <v-container fluid class="formEventTaxes">
                        <v-row>
                            <v-col cols="12" class="text-left pt-0">
                                <span class="ml-5">{{ $t("page.events.pricing.text6") }}</span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-data-table 
                                :headers="headersEventTaxes" 
                                :items="itemsEventTaxes" 
                                class="elevation-1"
                                :footer-props="{
                                    'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                    'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                                }"
                                :no-data-text="$t('dataTable.noDataText')"
                                :headerProps="{
                                    'sort-by-text': $t('dataTable.sortByText')
                                }"
                            >
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-dialog v-model="dialogEventTaxes" max-width="600px" persistent>
                                            <template v-slot:activator="{ on }">
                                                <v-btn color="primary" dark class="mb-2 primary" v-on="on"
                                                    @click="openModalEventTaxes()">
                                                    <v-icon left dark>fa-plus</v-icon>
                                                    {{ $t('common.form.add_event_taxes') }}
                                                </v-btn>
                                            </template>
                                            <v-form ref="formEventTaxes" class="formEventTaxes">
                                                <v-card>
                                                    <v-card-title>
                                                        <span class="headline">{{ titleEventTaxes }}</span>
                                                    </v-card-title>
                                                    <v-card-text>

                                                        <v-row class="mt-2">
                                                            <v-col cols="12">
                                                                <v-select :items="countryItems"
                                                                    v-model="eventTaxes.country" dense outlined
                                                                    :label="$t('common.form.country')" return-object
                                                                    @change="getStatesByCountry(), eventTaxes.state = ''"
                                                                    ref="inputCountry"
                                                                    :no-data-text="$t('common.no_data')"
                                                                >
                                                                    <template v-slot:item="{ item }">
                                                                        <div v-html="item" />
                                                                    </template>
                                                                    <template v-slot:selection="{ item }">
                                                                        <div v-html="item" />
                                                                    </template>
                                                                </v-select>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-select :items="stateItems" v-model="eventTaxes.state"
                                                                    dense outlined :label="$t('common.form.state')"
                                                                    return-object ref="inputState">
                                                                    <template v-slot:item="{ item }"
                                                                    :no-data-text="$t('common.no_data')"
                                                                >
                                                                        <div v-html="item" />
                                                                    </template>
                                                                    <template v-slot:selection="{ item }">
                                                                        <div v-html="item" />
                                                                    </template>
                                                                </v-select>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-select :items="sourceItems"
                                                                    v-model="eventTaxes.source" item-value="id"
                                                                    item-text="name" dense outlined
                                                                    :label="$t('common.form.taxes-included')"
                                                                    return-object :rules="sourceRules"
                                                                    ref="inputSource"
                                                                    :no-data-text="$t('common.no_data')"
                                                                >
                                                                    <template v-slot:item="{ item }">
                                                                        <div v-html="item.name" />
                                                                    </template>
                                                                    <template v-slot:selection="{ item }">
                                                                        <div v-html="item.name" />
                                                                    </template>
                                                                </v-select>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-select :items="typeItems" v-model="eventTaxes.type"
                                                                    item-value="id" item-text="name" dense outlined
                                                                    :label="$t('common.form.taxes-percentage')"
                                                                    return-object :rules="typeRules"
                                                                    @change="customSendAmountP" ref="inputType"
                                                                    :no-data-text="$t('common.no_data')"
                                                                >
                                                                    <template v-slot:item="{ item }">
                                                                        <div v-html="item.name" />
                                                                    </template>
                                                                    <template v-slot:selection="{ item }">
                                                                        <div v-html="item.name" />
                                                                    </template>
                                                                </v-select>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-text-field hide-details="auto"
                                                                    :label="$t('common.form.amount-percentage')"
                                                                    v-model="eventTaxes.amountPercentage"
                                                                    style="margin: 0 0 4px" outlined
                                                                    @input="customSendAmountP" dense :rules="taxRules"
                                                                    ref="inputTax"></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-text-field hide-details="auto"
                                                                    :label="$t('common.form.tax-label')"
                                                                    v-model="eventTaxes.taxLabel" outlined dense
                                                                    :rules="taxLabelRules"
                                                                    ref="inputTaxLabel"></v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <v-text-field hide-details="auto"
                                                                    :label="$t('common.form.tax-number')"
                                                                    v-model="eventTaxes.taxNumber" outlined dense
                                                                    :rules="taxNumberRules"
                                                                    ref="inputTaxNumber"></v-text-field>
                                                            </v-col>
                                                        </v-row>

                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="darken-1" dark small @click="closeEventTaxes">{{ $tc('common.form.cancel') }}</v-btn>
                                                        <v-btn color="darken-1" dark small
                                                            :disabled="!eventTaxesFormIsValid"
                                                            @click="saveEventTaxes">{{ $tc('common.form.save') }}</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-form>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-icon small class="mr-2" @click="editEventTaxes(item)">mdi-pencil</v-icon>
                                    <v-icon small @click="confirmDeleteEventTaxes(item)">mdi-delete</v-icon>
                                </template>
                            </v-data-table>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header color="accent" class="text-customizer-accent">
                    {{ $t("page.events.pricing.event-pricing") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <br />
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12" class="text-left py-0">
                                <p>{{ $t("page.events.pricing.description-pricing") }}</p>
                            </v-col>
                            <v-col cols="12" md="4" sm="4" class="pt-0">
                                <v-text-field v-model="regFee" @blur="saveRegFee" type="number" hide-details dense
                                    outlined :label="$t('page.events.pricing.one-simple-cost')"
                                    prepend-icon="fas fa-dollar-sign"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-data-table 
                            :headers="headers" 
                            :items="rows" 
                            class="elevation-1 eventPricingTable"
                            :footer-props="{
                                'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                            }"
                            :no-data-text="$t('dataTable.noDataText')"
                            :headerProps="{
                                'sort-by-text': $t('dataTable.sortByText')
                            }"
                        >
                            <template v-slot:top>
                                <v-toolbar flat color="white">
                                    <v-dialog v-model="dialog" max-width="600px" persistent>
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="primary" dark class="mb-2 primary" v-on="on"
                                                @click="openModal()">
                                                <v-icon left dark>fa-plus</v-icon>
                                                {{ $t('common.form.add') }}
                                            </v-btn>
                                            <span style="margin-left: 2rem">{{ $t("page.events.pricing.text1")
                                                }}</span>
                                        </template>
                                        <v-form ref="formEventPrice" class="formEventTaxes">
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline">{{ $tc('page.events.pricing.event-pricing-options') }}</span>
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-row class="mt-2">
                                                        <v-col cols="12">
                                                            <v-text-field outlined dense
                                                                :label="$t('page.events.pricing.price')"
                                                                v-model="eventPrice.price" :rules="priceRules">
                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-switch v-model="eventPrice.isPerClass"
                                                                :label="$t('page.events.pricing.isPerClass')"
                                                                style="margin-top: 0;">
                                                            </v-switch>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-text-field outlined dense
                                                                :label="$t('page.events.pricing.english-description')"
                                                                v-model="eventPrice.description"
                                                                :rules="descriptionRules"
                                                                :hint="$t('page.events.pricing.english-description-mandatory')"
                                                                persistent-hint>
                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-text-field outlined dense
                                                                :label="$t('page.events.pricing.french-description')"
                                                                v-model="eventPrice.frenchDescription"
                                                                :hint="$t('page.events.pricing.french-description-optional')"
                                                                persistent-hint>
                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-text-field outlined dense
                                                                :label="$t('page.events.pricing.spanish-description')"
                                                                v-model="eventPrice.spanishDescription"
                                                                :hint="$t('page.events.pricing.spanish-description-optional')"
                                                                persistent-hint>
                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>

                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-autocomplete
                                                                outlined
                                                                dense
                                                                multiple
                                                                chips
                                                                small-chips
                                                                deletable-chips
                                                                :items="eventClasses"
                                                                item-text="name"
                                                                item-value="id"
                                                                label="Allowed Classes"
                                                                v-model="eventPrice.allowedClassIds"
                                                                :rules="allowedClassRules"
                                                                hint="Select which classes can use this pricing option."
                                                                persistent-hint
                                                            ></v-autocomplete>
                                                        </v-col>
                                                    </v-row>

                                                    <v-row v-if="registrationType === 1 && eventLetters.length > 0">
                                                        <v-col cols="12">
                                                            <div class="text-subtitle-2 mb-1">Allowed Letters (Lottery only)</div>
                                                            <div class="text-caption mb-2">Select which letters this pricing option can use. Leave empty for no restriction.</div>
                                                            <div class="d-flex flex-wrap">
                                                                <v-checkbox
                                                                    v-for="letter in eventLetters"
                                                                    :key="letter.id"
                                                                    v-model="eventPrice.allowedLetterIds"
                                                                    :label="letter.letter"
                                                                    :value="letter.id"
                                                                    dense
                                                                    hide-details
                                                                    class="mr-4 mt-0"
                                                                ></v-checkbox>
                                                            </div>
                                                        </v-col>
                                                    </v-row>

                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="darken-1" dark small @click="close">{{ $t('common.form.cancel') }}</v-btn>
                                                    <v-btn color="darken-1" dark small @click="save">{{ $t('common.form.save') }}</v-btn>
                                                </v-card-actions>

                                            </v-card>
                                        </v-form>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                                <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
                            </template>
                        </v-data-table>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header color="accent" class="text-customizer-accent">
                    {{ $t("page.events.pricing.class-pricing") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12">
                                <p style="text-align: left;" class="mb-0">{{ $t("page.events.pricing.text2") }}</p>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field append-icon="mdi-magnify" hide-details outlined dense
                                    v-model="classNameFilterValue" type="text"
                                    :label="$t('common.table.class-name')"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                                <v-text-field append-icon="mdi-magnify" hide-details outlined dense
                                    v-model="priceFilterValue" type="text"
                                    :label="$t('common.table.price')"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <div class="class-pricing-wrapper">
                                <v-data-table
                                    :headers="headersClass"
                                    :items="rowsClass"
                                    class="elevation-1 mb-1 class-pricing-table"
                                    :sort-by="sortByClass"
                                    :sort-desc="sortDescClass"
                                    item-key="id"
                                    :mobile-breakpoint="0"
                                    :footer-props="{
                                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                                    }"
                                    :no-data-text="$t('dataTable.noDataText')"
                                    :headerProps="{
                                        'sort-by-text': $t('dataTable.sortByText')
                                    }"
                                >
                                    <template v-slot:body="{ items, headers }">
                                        <tbody>
                                            <tr v-if="!items.length">
                                                <td :colspan="headers.length" class="text-center">{{ $t('dataTable.noDataText') }}</td>
                                            </tr>
                                            <template v-for="item in items">
                                                <tr :key="item.id" class="class-row">
                                                    <td class="class-col-expand">
                                                        <v-icon @click="toggleExpand(item)">{{ isClassExpanded(item) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                                    </td>
                                                    <td>{{ item.className }}</td>
                                                    <td>$ {{ resolveCurrentPrice(item.id) }}</td>
                                                    <td>{{ (classDynamicPrices[item.id] || []).length }}</td>
                                                </tr>
                                                <template v-if="isClassExpanded(item)">
                                                    <tr :key="'title-' + item.id" class="dynamic-tier-expanded">
                                                        <td class="class-col-expand"></td>
                                                        <td>
                                                            <strong>{{ item.className }} — {{ $t('common.form.pricing.dynamic-pricing-tiers') }}</strong>
                                                        </td>
                                                        <td colspan="2" class="text-right">
                                                            <v-btn small color="primary" @click="openAddTierDialog(item.id)">
                                                                <v-icon left small>fa-plus</v-icon>
                                                                {{ $t('common.form.pricing.add-tier') }}
                                                            </v-btn>
                                                        </td>
                                                    </tr>
                                                    <tr :key="'subheader-' + item.id" class="dynamic-tier-subheader">
                                                        <td class="class-col-expand"></td>
                                                        <td class="text-caption font-weight-bold grey--text text--darken-1">{{ $t('common.form.pricing.days-before-event') }}</td>
                                                        <td class="text-caption font-weight-bold grey--text text--darken-1">{{ $t('common.form.pricing.price-dollar') }}</td>
                                                        <td class="text-caption font-weight-bold grey--text text--darken-1">{{ $t('common.form.pricing.actions') }}</td>
                                                    </tr>
                                                    <tr v-if="!(classDynamicPrices[item.id] || []).length" :key="'empty-' + item.id" class="dynamic-tier-row">
                                                        <td class="class-col-expand"></td>
                                                        <td colspan="3" class="text-center grey--text py-3">{{ $t('common.form.pricing.no-tiers-defined') }}</td>
                                                    </tr>
                                                    <tr
                                                        v-for="tier in sortedTiers(item.id)"
                                                        :key="'tier-' + tier.id"
                                                        :class="['dynamic-tier-row', { 'active-tier': isActiveTier(tier, item.id) }]"
                                                    >
                                                        <td class="class-col-expand"></td>
                                                        <td>{{ tier.daysBeforeEvent }}</td>
                                                        <td>$ {{ parseFloat(tier.price).toFixed(2) }}</td>
                                                        <td>
                                                            <v-icon small class="mr-2" @click="openEditTierDialog(tier)">mdi-pencil</v-icon>
                                                            <v-icon small @click="confirmDeleteDynamicTier(tier)">mdi-delete</v-icon>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </template>
                                </v-data-table>
                                </div>

                                <!-- Add/Edit Dynamic Tier Dialog -->
                                <v-dialog v-model="dynamicPriceDialog" max-width="480px" persistent>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ isNewTier ? $t('common.form.pricing.add-pricing-tier') : $t('common.form.pricing.edit-tier') }}</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-form ref="formDynamicTier">
                                                <v-row class="mt-1">
                                                    <v-col cols="12">
                                                        <v-text-field
                                                            outlined dense
                                                            :label="$t('common.form.pricing.days-before-event')"
                                                            v-model.number="editedDynamicTier.daysBeforeEvent"
                                                            type="number"
                                                            :rules="[v => (v !== '' && v !== null && v !== undefined) || $t('common.form.pricing.field-required'), v => v >= 0 || $t('common.form.pricing.value-min-zero')]"
                                                            :hint="$t('common.form.pricing.event-day-price-hint')"
                                                            persistent-hint
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-text-field
                                                            outlined dense
                                                            :label="$t('common.form.pricing.price-dollar')"
                                                            v-model.number="editedDynamicTier.price"
                                                            type="number"
                                                            step="0.01"
                                                            :rules="[v => (v !== '' && v !== null && v !== undefined) || $t('common.form.pricing.field-required')]"
                                                            prepend-icon="fas fa-dollar-sign"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-form>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="darken-1" dark small @click="closeDynamicTierDialog">{{ $t('common.form.cancel') }}</v-btn>
                                            <v-btn color="darken-1" dark small @click="saveClassDynamicPrice">{{ $t('common.form.save') }}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header color="accent" class="text-customizer-accent">
                    {{ $t("page.events.pricing.family-friend-pricing") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <FamilyFriendPricing />
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header color="accent" class="text-customizer-accent">
                    {{ $t("page.events.pricing.level-pricing-for-classes") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <br />
                    <v-container fluid>
                        <p style="text-align: left; margin-left: 20px">{{ $t("page.events.pricing.text4") }}</p>
                        <v-data-table 
                            :headers="headersLevelClass" 
                            :items="rowsLevelClass" 
                            class="elevation-1"
                            :footer-props="{
                                'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                            }"
                            :no-data-text="$t('dataTable.noDataText')"
                            :headerProps="{
                                'sort-by-text': $t('dataTable.sortByText')
                            }"  
                        >
                            <template v-slot:top>
                                <v-toolbar flat color="white">
                                    <v-dialog v-model="dialogLevelClass" max-width="600px" persistent>
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="primary" dark class="mb-2 primary" v-on="on"
                                                @click="openModalLevelClass()">
                                                <v-icon left dark>fa-plus</v-icon>
                                                {{ $t('common.form.add-pricing-level') }}
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-title>
                                                <span class="headline">{{ titleLevelClass }}</span>
                                            </v-card-title>

                                            <v-card-text>
                                                <v-form ref="formLevelClassPrice">
                                                    <br />
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-text-field outlined dense
                                                                :label="$t('page.events.pricing.level-number')"
                                                                v-model="levelClassPrice.level" :rules="levelClassRules"
                                                                @input="uniqueLevel = false">
                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-text-field outlined dense
                                                                :label="$t('page.events.pricing.price')"
                                                                v-model="levelClassPrice.price" :rules="priceRules">
                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-form>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="darken-1" dark small @click="closeLevelClass">{{ $t('common.form.cancel') }}</v-btn>
                                                <v-btn color="darken-1" dark small @click="saveLevelClass">{{ $t('common.form.save') }}</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon small class="mr-2" @click="editItemLevelClass(item)">mdi-pencil</v-icon>
                                <v-icon small @click="confirmDeleteLevelClass(item)">mdi-delete</v-icon>
                            </template>
                        </v-data-table>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Coupon discount -->
            <v-expansion-panel>
                <v-expansion-panel-header color="accent" class="text-customizer-accent">
                    {{ $t("page.events.pricing.coupon-discount") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <CouponDiscount ref="CouponDiscount" />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')"
            @cancel="dialogNotification = false;" @agree="deleteItem" type='warning' />
        <SGSNotificationConfirm v-if="dialogNotificationClass" :notificationMessage="$t('common.confirm-delete')"
            @cancel="dialogNotificationClass=false;" @agree="deleteItemClass" type='warning' />
        <SGSNotificationConfirm v-if="dialogNotificationLevelClass" :notificationMessage="$t('common.confirm-delete')"
            @cancel="dialogNotificationLevelClass=false;" @agree="deleteItemLevelClass" type='warning' />
        <SGSNotificationConfirm v-if="dialogNotificationPF" :notificationMessage="$t('common.confirm-delete')"
            @cancel="dialogNotificationPF=false;" @agree="deleteItemPF" type='warning' />
        <SGSNotificationConfirm v-if="dialogNotificationCoupon" :notificationMessage="$t('common.confirm-delete')"
            @cancel="dialogNotificationCoupon=false;" @agree="deleteItemCD" type='warning' />
        <SGSNotificationConfirm v-if="dialogNotificationET" :notificationMessage="$t('common.confirm-delete')"
            @cancel="dialogNotificationET=false;" @agree="deleteItemET" type='warning' />
        <SGSNotificationConfirm v-if="dialogNotificationDynamicTier" :notificationMessage="$t('common.confirm-delete')"
            @cancel="dialogNotificationDynamicTier=false;" @agree="deleteClassDynamicPrice" type='warning' />
        <SGSNotificationAlert v-if="errorDialog" :notificationMessage="$t(`page.events.pricing.${errorDialogMessage}`)"
            @cancel="errorDialog=false;" type='error' />
    </v-container>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";
import countryregion from "@/assets/data/countryregion.json";
import FamilyFriendPricing from "@/components/pricing/FamilyFriendPricing.vue";
import CouponDiscount from "@/components/pricing/CouponDiscount.vue";

export default {
    name: 'Pricing',
    mixins: [apiCalls],
    components: { SGSNotificationConfirm, FamilyFriendPricing, SGSNotificationAlert, CouponDiscount },
    data()
    {
        return {
            maxRowPF: false,
            classNameFilterValue: '',
            priceFilterValue: '',
            rows: [],
            dialog: false,
            dialogNotification: false,
            rowsClass: [],
            eventPrice: {
                description: null,
                price: null,
                isPerClass: true,
                frenchDescription: null,
                spanishDescription: null,
                allowedLetterIds: [],
                allowedClassIds: []
            },
            registrationType: null,
            eventLetters: [],
            eventClasses: [],
            bandCreate: false,
            itemPricingSel: null,
            classPrice: {
                name: null,
                price: null
            },
            dialogClass: false,
            dialogNotificationClass: false,
            dialogPricingF: false,
            itemClassSel: null,
            costPerson: null,
            rowsLevelClass: [],
            dialogLevelClass: false,
            bandCreateLC: false,
            levelClassPrice: {
                level: null,
                price: null
            },
            itemLevelClassSel: null,
            dialogNotificationLevelClass: false,
            uniqueLevel: false,
            regFee: parseFloat(0).toFixed(2),
            eventPriceFriend: {
                price: null,
                english: null,
                spanish: null,
                french: null
            },
            languageItems: [],
            bandCreatePF: false,
            rowsSpectatorsL: [],
            dialogNotificationPF: false,
            countryItems: [],
            eventTaxes: {
                id: null,
                country: null,
                state: null,
                source: null,
                type: null,
                amountPercentage: null,
                taxLabel: null,
                taxNumber: null
            },
            stateItems: [],
            sourceItems: [],
            typeItems: [],
            userId: 0,
            itemCouponSel: null,
            dialogNotificationCoupon: false,
            itemsEventTaxes: [],
            dialogEventTaxes: false,
            dialogNotificationET: false,
            itemEventTaxesSel: null,
            errorDialog: false,
            errorDialogMessage: '',
            sortByClass: ['className'],
            sortDescClass: [false],
            titleLevelClass: this.$t('common.form.add-pricing-level'),
            titleEventTaxes: this.$t('common.form.add_event_taxes'),
            classDynamicPrices: {},
            classEventDate: null,
            classEventTimezone: null,
            classDaysUntilEvent: null,
            dynamicPriceDialog: false,
            editedDynamicTier: { raceClassId: null, daysBeforeEvent: null, price: null },
            editedDynamicTierId: null,
            isNewTier: true,
            expandedClasses: [],
            dialogNotificationDynamicTier: false,
            dynamicTierToDelete: null
        }
    },
    computed: {
        eventTaxesFormIsValid()
        {
            return (
                this.eventTaxes.country && this.eventTaxes.source &&
                this.eventTaxes.type && this.eventTaxes.taxLabel &&
                this.eventTaxes.amountPercentage
            );
        },
        headersEventTaxes: function ()
        {
            return [
                {
                    text: this.$t("common.table.tax_country"),
                    value: "country"
                },
                {
                    text: this.$t("common.table.tax_state"),
                    value: "state"
                },
                {
                    text: this.$t("common.table.tax_source"),
                    value: "source"
                },
                {
                    text: this.$t("common.table.tax_type"),
                    value: "type"
                },
                {
                    text: this.$t("common.table.tax_value"),
                    value: "amountPercentage"
                },
                {
                    text: this.$t("common.table.tax_label"),
                    value: "taxLabel"
                },
                {
                    text: this.$t("common.table.tax_number"),
                    value: "taxNumber"
                },
                {
                    text: this.$t("common.table.actions"),
                    value: "actions",
                    sortable: false
                }
            ]
        },
        headers: function ()
        {
            return [
                {
                    text: this.$t("common.table.description"),
                    value: "description"
                },
                {
                    text: this.$t("common.table.isPerClass"),
                    align: "start",
                    value: "isPerClassText"
                },
                {
                    text: this.$t("common.table.price"),
                    value: "price"
                },
                {
                    text: this.$t("common.table.actions"),
                    value: "actions",
                    sortable: false
                }
            ];
        },
        headersClass: function ()
        {
            return [
                {
                    text: '',
                    value: 'expand',
                    sortable: false,
                    width: '40px',
                    class: 'class-col-expand'
                },
                {
                    text: this.$t("common.table.class-name"),
                    value: "className",
                    sortable: true,
                    filter: this.classNameFilter
                },
                {
                    text: this.$t('common.form.pricing.current-price'),
                    value: "price",
                    sortable: false,
                    filter: this.priceFilter
                },
                {
                    text: this.$t('common.form.pricing.tiers'),
                    value: "tiersCount",
                    sortable: false
                }
            ];
        },
        headersLevelClass: function ()
        {
            return [
                {
                    text: this.$t("common.table.level-number"),
                    value: "level"
                },
                {
                    text: this.$t("common.table.price"),
                    value: "price"
                },
                {
                    text: this.$t("common.table.actions"),
                    value: "actions",
                    sortable: false
                }
            ];
        },
        headersPricingFriends: function ()
        {
            return [
                {
                    text: this.$t("common.table.description"),
                    value: "information"
                },
                {
                    text: this.$t("common.table.price"),
                    value: "price"
                },
                {
                    text: this.$t("common.table.actions"),
                    value: "actions",
                    sortable: false
                }
            ]
        },
        formTitle: function ()
        {
            return this.$t("page.events.pricing.create-new-pricing");
        },
        descriptionRules: function ()
        {
            return [v => !!v || this.$t("page.events.pricing.description-required")];
        },
        priceClassRules: function ()
        {
            const regInt = new RegExp('[0-9]+');
            const regFloat = new RegExp(/[0-9]+\.[0-9]{1,2}/);
            const regIntNeg = new RegExp('-[0-9]+');
            const regFloatNeg = new RegExp(/-[0-9]+\.[0-9]{1,2}/);
            return [
                v => !!v || this.$t("page.events.pricing.price-required"),
                (v) =>
                {
                    const auxV = v ? v.toString() : "";
                    const resultInt = auxV.split(regInt).filter(el => el != "");
                    const resultFloat = auxV.split(regFloat).filter(el => el != "");
                    const resultIntNeg = auxV.split(regIntNeg).filter(el => el != "");
                    const resultFloatNeg = auxV.split(regFloatNeg).filter(el => el != "");
                    return !(resultInt.length > 0 && resultFloat.length > 0 && resultIntNeg.length > 0 && resultFloatNeg.length > 0) ||
                        this.$t("page.events.pricing.price-invalid");
                }
            ];
        },
        priceRules: function ()
        {
            const regInt = new RegExp('[0-9]+');
            const regFloat = new RegExp(/[0-9]+\.[0-9]{1,2}/);
            return [
                v => !!v || this.$t("page.events.pricing.price-required"),
                (v) =>
                {
                    const auxV = v ? v.toString() : "";
                    const resultInt = auxV.split(regInt).filter(el => el != "");
                    const resultFloat = auxV.split(regFloat).filter(el => el != "");
                    return !(resultInt.length > 0 && resultFloat.length > 0) || this.$t("page.events.pricing.price-invalid");
                }
            ];
        },
        nameRules: function ()
        {
            return [v => !!v || this.$t("page.events.pricing.name-required")];
        },
        levelClassRules: function ()
        {
            const regInt = new RegExp('[0-9]+');
            return [
                v => !!v || this.$t("page.events.pricing.level-required"),
                (v) =>
                {
                    const auxV = v ? v.toString() : "";
                    const resultInt = auxV.split(regInt).filter(el => el != "");
                    return !(resultInt.length > 0) || this.$t("page.events.pricing.level-invalid");
                },
                !this.uniqueLevel || this.$t("page.events.pricing.unique-level")
            ];
        },
        languageRules: function ()
        {
            return [v => !!v || this.$t("page.events.pricing.language-required")];
        },
        informationRules: function ()
        {
            return [v => !!v || this.$t("page.events.pricing.information-required")];
        },
        sourceRules: function ()
        {
            return [v => !!v || this.$t("page.events.pricing.source-required")];
        },
        allowedClassRules: function ()
        {
            return [
                v => (Array.isArray(v) && v.length > 0) || 'Select at least one class'
            ];
        },
        typeRules: function ()
        {
            return [v => !!v || this.$t("page.events.pricing.type-required")];
        },
        taxRules: function ()
        {
            const regInt = new RegExp('[0-9]+');
            const regFloat = new RegExp(/[0-9]+\.[0-9]{1,4}/);
            return [
                v =>
                {
                    const auxV = v ? v.toString() : "";
                    let aux1 = auxV.replace('%', '');
                    let aux = aux1.replace('$', '');
                    return !(aux.length == 0) || this.$t("page.events.pricing.amount-percentage-required")
                },
                v =>
                {
                    const auxV = v ? v.toString() : "";
                    let aux1 = auxV.replace('%', '');
                    let aux = aux1.replace('$', '');
                    const resultInt = aux.split(regInt).filter(el => el != "");
                    const resultFloat = aux.split(regFloat).filter(el => el != "");
                    return (!(resultInt.length > 0 && resultFloat.length > 0) ||
                        this.$t("page.events.pricing.amount-percentage-invalid"));
                },
                v =>
                {
                    const auxV = v ? v.toString() : "";
                    let aux1 = auxV.replace('%', '');
                    let aux = aux1.replace('$', '');
                    const auxLength = aux.split('.');
                    const resultLength = auxLength[0].length > 4;
                    return (!resultLength ||
                        this.$t("page.events.pricing.amount-percentage-maxlength"));
                }
            ];
        },
        taxLabelRules: function ()
        {
            return [
                v => !!v || this.$t("page.events.pricing.tax-label-required"),
                v => (v || '').length <= 200 || this.$t("page.events.pricing.tax-label-max")
            ];
        },
        taxNumberRules: function ()
        {
            return [
                //v => !!v || this.$t("page.events.pricing.tax-number-required"),
                v => (v || '').length <= 50 || this.$t("page.events.pricing.tax-number-max")
            ];
        },
        eventID()
        {
            return this.$route.params.id;
        }
    },
    methods: {
        classNameFilter(value)
        {
            if (!this.classNameFilterValue)
                return true;
            return String(value ?? '').toLowerCase().includes(this.classNameFilterValue.toLowerCase());
        },
        priceFilter(value)
        {
            if (!this.priceFilterValue)
                return true;
            return String(value ?? '').toLowerCase().includes(this.priceFilterValue.toLowerCase());
        },
        async deleteItemET()
        {
            const response = await this.api(
                "delete",
                "/api/v1/promoter/eventRegistrationPrice/eventTaxes/" + this.userId + "/" + this.itemEventTaxesSel.id
            );
            if (response.success == 1)
            {
                this.itemsEventTaxes = [];
                this.loadEventTaxes();
            }
            this.dialogNotificationET = false;
            this.itemEventTaxesSel = null;
        },
        async loadUser()
        {
            const response = await this.api("get", "/api/v1/users/current")
            if (response.success == 1)
            {
                this.userId = response.message.id;

                const responseEvent = await this.api("get", "/api/v1/promoter/isEventOwner/" + this.$route.params.id)
                if (!responseEvent)
                {
                    window.location.href = `${process.env.VUE_APP_ROOT}/login?message=You20are%20logged%20out!`;
                }

            }
        },
        async loadPricing()
        {
            const response = await this.api(
                "get",
                "/api/v1/promoter/eventRegistrationPrice/" + this.$route.params.id
            );
            if (response.success)
            {
                this.registrationType = response.message.registrationType != null ? response.message.registrationType : null;
                this.eventLetters = response.message.eventLetters || [];
                this.eventClasses = response.message.eventClasses || [];
                this.rows = response.message.data.map((el) =>
                {
                    let fDesc = el.descriptions.filter((el) =>
                    {
                        return el.languageCode == "fr";
                    });
                    let sDesc = el.descriptions.filter((el) =>
                    {
                        return el.languageCode == "es";
                    });
                    return {
                        id: el.id,
                        description: el.description,
                        isPerClass: el.isPerClass ? true : false,
                        isPerClassText: el.isPerClass ? this.$t('common.form.yes') : this.$t('common.form.no'),
                        price: `$ ${parseFloat(el.price).toFixed(2)}`,
                        frenchDescription: fDesc.length > 0 ? fDesc[0].description : null,
                        spanishDescription: sDesc.length > 0 ? sDesc[0].description : null,
                        allowedLetterIds: el.allowedLetterIds || [],
                        allowedClassIds: el.allowedClassIds || []
                    };
                });
            }
        },
        async loadClasses()
        {
            const response = await this.api(
                "get",
                "/api/v1/promoter/eventClass/" + this.$route.params.id
            );
            if (response.success)
            {
                this.rowsClass = response.message.data.map((el) =>
                {
                    return {
                        id: el.id,
                        className: el.cName || '',
                        price: '0.00'
                    }
                });
            }
        },
        async loadCostPerson()
        {
            const response = await this.api(
                "get",
                "/api/v1/promoter/eventRegistrationPrice/getEventCostPerson/" + this.$route.params.id
            );

            if (response.success && response.message.data)
            {
                this.costPerson = parseFloat(response.message.data.price).toFixed(2);
            } else
            {
                this.costPerson = '0.00';
            }
        },
        async loadLevelClasses()
        {
            const response = await this.api(
                "get",
                "/api/v1/promoter/eventRegistrationPrice/levelClass/" + this.$route.params.id
            );

            if (response.success)
            {
                this.rowsLevelClass = response.message.data.map((el) =>
                {
                    return {
                        id: el.id,
                        level: el.level,
                        price: `$ ${parseFloat(el.price).toFixed(2)}`
                    }
                });
            }
        },
        async loadRegFee()
        {
            const response = await this.api(
                "get",
                "/api/v1/promoter/eventRegFee/" + this.$route.params.id
            );

            if (response.success)
            {
                response.message.data.map((el) =>
                {
                    this.regFee = Number.parseFloat(el.regFee).toFixed(2);
                });

            }
        },
        async loadLanguage()
        {
            const response = await this.api(
                "get",
                "/api/v1/langs/available"
            );
            this.languageItems = response;
        },
        loadCountries()
        {
            this.countryItems = countryregion.countries;
        },
        getStatesByCountry()
        {
            this.stateItems = countryregion.regions[this.eventTaxes.country];
        },
        async loadSources()
        {
            const response = await this.api(
                "get",
                "/api/v1/promoter/eventRegistrationPrice/eventTaxes/getListSource"
            );
            if (response.success)
            {
                this.sourceItems = response.message.data;
            }
        },
        async loadTypes()
        {
            const response = await this.api(
                "get",
                "/api/v1/promoter/eventRegistrationPrice/eventTaxes/getListType"
            );
            if (response.success)
            {
                this.typeItems = response.message.data;
            }
        },
        async loadEventTaxes()
        {
            const response = await this.api(
                "get",
                "/api/v1/promoter/eventRegistrationPrice/eventTaxes/getTax/" + this.$route.params.id
            );
            if (response.success && response.message.data.length > 0)
            {
                this.itemsEventTaxes = response.message.data.map((el) =>
                {
                    return {
                        id: el.id,
                        country: el.country,
                        state: el.state,
                        sourceId: el.fkEventTaxesSourceId,
                        source: el.source,
                        typeId: el.fkEventTaxesType,
                        type: el.type,
                        amountPercentage: el.type == 'fixed' ? `$${el.tax}` : `${el.tax}%`,
                        taxV: el.tax,
                        taxLabel: el.taxLabel,
                        taxNumber: el.taxNumber
                    }
                });
            }
        },
        openModalEventTaxes()
        {
            this.dialogEventTaxes = true;
        },
        openModal()
        {
            this.dialog = true;
            this.bandCreate = true;
        },
        openModalPF()
        {
            this.maxRowPF = false;
            if (this.rowsSpectatorsL.length == 0)
            {
                this.dialogPricingF = true;
                this.bandCreatePF = true;
            } else
            {
                this.maxRowPF = true;
            }
        },
        openModalLevelClass()
        {
            this.titleLevelClass = this.$t('common.form.add-pricing-level');
            this.dialogLevelClass = true;
            this.bandCreateLC = true;
            this.uniqueLevel = false;
        },
        editItem(item)
        {
            this.itemPricingSel = item;
            this.eventPrice.description = item.description;
            this.eventPrice.price = item.price.replace("$", "").replace(" ", "");
            this.eventPrice.isPerClass = item.isPerClass;
            this.eventPrice.frenchDescription = item.frenchDescription;
            this.eventPrice.spanishDescription = item.spanishDescription;
            this.eventPrice.allowedLetterIds = item.allowedLetterIds ? [...item.allowedLetterIds] : [];
            this.eventPrice.allowedClassIds = item.allowedClassIds ? [...item.allowedClassIds] : [];
            this.dialog = true;
        },
        editEventTaxes(item)
        {
            this.titleEventTaxes = this.$t('common.form.edit_event_taxes');
            this.eventTaxes = {
                id: item.id,
                country: item.country,
                state: item.state,
                amountPercentage: item.amountPercentage,
                taxLabel: item.taxLabel,
                taxNumber: item.taxNumber,
                //source: item.sourceId,
                //type: item.typeId
            }
            this.getStatesByCountry();
            this.sourceItems.find(x =>
            {
                if (x.id == item.sourceId)
                {
                    this.eventTaxes.source = {
                        id: x.id,
                        name: x.name,
                        created_at: x.created_at,
                        updated_at: x.updated_at
                    };
                }
            });
            this.typeItems.find(x =>
            {
                if (x.id == item.typeId)
                {
                    this.eventTaxes.type = {
                        id: x.id,
                        name: x.name,
                        created_at: x.created_at,
                        updated_at: x.updated_at
                    };
                }
            });
            this.dialogEventTaxes = true;
        },
        editItemPF(item)
        {
            this.itemFriendSel = item;
            this.eventPriceFriend.spanish = item.spanishDescription;
            this.eventPriceFriend.french = item.frenchDescription;
            this.eventPriceFriend.english = item.information;
            this.eventPriceFriend.price = item.price.replace("$", "").replace(" ", "");
            this.dialogPricingF = true;
        },
        confirmDeleteEventTaxes(item)
        {
            this.dialogNotificationET = true;
            this.itemEventTaxesSel = item;
        },
        confirmDelete(item)
        {
            this.dialogNotification = true;
            this.itemPricingSel = item;
        },
        confirmDeletePF(item)
        {
            this.dialogNotificationPF = true;
            this.itemFriendSel = item;
        },
        editItemClass(item)
        {
            this.itemClassSel = item;
            this.classPrice.name = item.className;
            this.classPrice.price = item.price.replace("$", "").replace(" ", "");
            this.dialogClass = true;
        },
        confirmDeleteClass(item)
        {
            this.dialogNotificationClass = true;
            this.itemClassSel = item;
        },
        editItemLevelClass(item)
        {
            this.titleLevelClass = this.$t('common.form.edit-pricing-level');
            this.itemLevelClassSel = item;
            this.levelClassPrice.level = item.level;
            this.levelClassPrice.price = item.price.replace("$", "").replace(" ", "");
            this.dialogLevelClass = true;
            this.uniqueLevel = false;
        },
        confirmDeleteLevelClass(item)
        {
            this.dialogNotificationLevelClass = true;
            this.itemLevelClassSel = item;
        },
        async deleteItem()
        {
            const response = await this.api(
                "delete",
                "/api/v1/promoter/eventRegistrationPrice/" + this.itemPricingSel.id
            );
            if (response.success)
            {
                this.loadPricing();
            }
            this.dialogNotification = false;
        },
        async deleteItemPF()
        {
            const response = await this.api(
                "delete",
                "/api/v1/promoter/eventRegistrationPrice/spectatorsLanguage/" + this.itemFriendSel.id
            );
            if (response.success)
            {
                this.maxRowPF = false;
                this.loadInformationLanguage();
            }
            this.dialogNotificationPF = false;
        },
        async deleteItemClass()
        {
            const response = await this.api(
                "delete",
                "/api/v1/promoter/eventClass/" + this.itemClassSel.id
            );
            if (response.success)
            {
                this.loadClasses();
            }
            this.dialogNotificationClass = false;
        },
        async deleteItemLevelClass()
        {
            const response = await this.api(
                "delete",
                "/api/v1/promoter/eventRegistrationPrice/levelClass/" + this.itemLevelClassSel.id
            );
            if (response.success)
            {
                this.loadLevelClasses();
            }
            this.dialogNotificationLevelClass = false;
        },
        clearEventPrice()
        {
            this.eventPrice = {
                description: null,
                frenchDescription: null,
                isPerClass: true,
                price: null,
                spanishDescription: null,
                allowedLetterIds: [],
                allowedClassIds: []
            };
        },
        close()
        {
            this.clearEventPrice();
            this.$refs.formEventPrice.resetValidation();
            this.bandCreate = false;
            this.dialog = false;
        },
        closePF()
        {
            this.$refs.formEventPriceFriend.resetValidation();
            this.$refs.formEventPriceFriend.reset();
            this.bandCreatePF = false;
            this.dialogPricingF = false;
        },
        closeClass()
        {
            this.dialogClass = false;
        },
        closeLevelClass()
        {
            this.bandCreateLC = false;
            this.dialogLevelClass = false;
        },
        closeEventTaxes()
        {
            this.$refs.formEventTaxes.resetValidation();
            this.$refs.formEventTaxes.reset();
            this.dialogEventTaxes = false;
        },
        async saveEventTaxes()
        {
            let _method = 'post';
            let data = {
                country: this.eventTaxes.country,
                state: this.eventTaxes.state,
                taxLabel: this.eventTaxes.taxLabel,
                taxNumber: this.eventTaxes.taxNumber ? this.eventTaxes.taxNumber.toString() : this.eventTaxes.taxNumber,
                source: this.eventTaxes.source.name,
                type: this.eventTaxes.type.name,
                sourceId: this.eventTaxes.source.id,
                typeId: this.eventTaxes.type.id,
                tax: this.cleanTax()
            }
            if (this.eventTaxes.id)
            {
                data.id = this.eventTaxes.id;
                _method = "put";
            }
            const response = await this.api(
                _method,
                "/api/v1/promoter/eventRegistrationPrice/eventTaxes/" + this.$route.params.id,
                data
            );
            if (response.success)
            {
                this.eventTaxes = {
                    id: null,
                    country: null,
                    state: null,
                    source: null,
                    type: null,
                    amountPercentage: null,
                    taxLabel: null,
                    taxNumber: null
                }
                this.loadEventTaxes();
                this.$refs.formEventTaxes.reset();
                this.$refs.formEventTaxes.resetValidation();
                this.dialogEventTaxes = false;
            } else
            {
                //display errors
            }
        },
        async saveRegFee()
        {
            if (this.regFee >= 0 || this.regFee == "")
            {
                const data = {
                    id: parseInt(this.$route.params.id),
                    regFee: this.regFee == "" ? parseFloat(0).toFixed(2) : parseFloat(this.regFee).toFixed(2)
                }
                const response = await this.api(
                    "put",
                    "/api/v1/promoter/eventRegFee",
                    data
                );
                if (response.success)
                {
                    this.loadRegFee();
                }
            }
        },
        async save()
        {
            if (this.$refs.formEventPrice.validate())
            {
                const data = {
                    eventId: parseInt(this.$route.params.id),
                    description: this.eventPrice.description,
                    price: parseFloat(this.eventPrice.price).toFixed(2),
                    isPerClass: this.eventPrice.isPerClass == null ? 0 : this.eventPrice.isPerClass,
                    frenchDescription: this.eventPrice.frenchDescription,
                    spanishDescription: this.eventPrice.spanishDescription,
                    allowedLetterIds: this.eventPrice.allowedLetterIds || [],
                    allowedClassIds: this.eventPrice.allowedClassIds || []
                };
                if (this.bandCreate)
                {
                    const response = await this.api(
                        "post",
                        "/api/v1/promoter/eventRegistrationPrice",
                        data
                    );
                    if (response.success)
                    {
                        this.loadPricing();
                        this.clearEventPrice();
                        this.$refs.formEventPrice.resetValidation();
                        this.bandCreate = false;
                        this.dialog = false;
                    }
                } else
                {
                    const response = await this.api(
                        "put",
                        "/api/v1/promoter/eventRegistrationPrice/" + this.itemPricingSel.id,
                        data
                    );
                    if (response.success)
                    {
                        this.loadPricing();
                        this.clearEventPrice();
                        this.$refs.formEventPrice.resetValidation();
                        this.dialog = false;
                    }
                }
            }
        },
        async savePF()
        {
            if (this.$refs.formEventPriceFriend.validate())
            {
                const data = {
                    eventId: parseInt(this.$route.params.id),
                    price: this.eventPriceFriend.price,
                    spanish: this.eventPriceFriend.spanish,
                    french: this.eventPriceFriend.french,
                    english: this.eventPriceFriend.english
                };
                if (this.bandCreatePF)
                {
                    const response = await this.api(
                        "post",
                        "/api/v1/promoter/eventRegistrationPrice/updateOrCreateCostPerson/" + this.$route.params.id,
                        data
                    );
                    if (response.success)
                    {
                        this.loadInformationLanguage();
                        this.bandCreatePF = false;
                        this.dialogPricingF = false;
                        this.$refs.formEventPriceFriend.resetValidation();
                        this.$refs.formEventPriceFriend.reset();
                    }
                } else
                {
                    const response = await this.api(
                        "put",
                        "/api/v1/promoter/eventRegistrationPrice/spectatorsLanguage/" + this.itemFriendSel.id,
                        data
                    );
                    if (response.success)
                    {
                        this.loadInformationLanguage();
                        this.dialogPricingF = false;
                        this.$refs.formEventPriceFriend.resetValidation();
                        this.$refs.formEventPriceFriend.reset();
                    }
                }
            }
        },
        async loadInformationLanguage()
        {
            const response = await this.api(
                "get",
                "/api/v1/promoter/eventRegistrationPrice/spectatorsLanguage/" + this.$route.params.id
            );
            if (response.success)
            {
                this.rowsSpectatorsL = response.message.data.map((el) =>
                {
                    let fDesc = el.descriptions.filter((el) =>
                    {
                        return el.languageCode == "fr";
                    });
                    let sDesc = el.descriptions.filter((el) =>
                    {
                        return el.languageCode == "es";
                    });
                    let eDesc = el.descriptions.filter((el) =>
                    {
                        return el.languageCode == "en";
                    });
                    return {
                        id: el.id,
                        information: eDesc.length > 0 ? eDesc[0].spectatorAddInfo : null,
                        price: `$ ${parseFloat(el.price).toFixed(2)}`,
                        frenchDescription: fDesc.length > 0 ? fDesc[0].spectatorAddInfo : null,
                        spanishDescription: sDesc.length > 0 ? sDesc[0].spectatorAddInfo : null
                    };
                });
            }
        },
        async saveClass()
        {
            if (this.$refs.formClassPrice.validate())
            {
                await this.api(
                    "put",
                    "/api/v1/promoter/eventRegistrationPrice/updateClassPrice/" + this.itemClassSel.id,
                    this.classPrice
                );
                this.loadClasses();
                this.dialogClass = false;
            }
        },
        async saveLevelClass()
        {
            if (this.$refs.formLevelClassPrice.validate())
            {
                const data = {
                    eventId: parseInt(this.$route.params.id),
                    level: this.levelClassPrice.level,
                    price: parseFloat(this.levelClassPrice.price).toFixed(2)
                };
                if (this.bandCreateLC)
                {
                    const response = await this.api(
                        "post",
                        "/api/v1/promoter/eventRegistrationPrice/levelClass",
                        data
                    );
                    if (response.success == 1)
                    {
                        this.loadLevelClasses();
                        this.bandCreateLC = false;
                        this.dialogLevelClass = false;
                    } else
                    {
                        const findUniqueValidate = Array.isArray(response.message) ? response.message.filter((el) =>
                        {
                            return el == 'unique_level';
                        }) : [];
                        if (findUniqueValidate.length > 0)
                        {
                            this.uniqueLevel = true;
                        }
                    }
                } else
                {
                    const response = await this.api(
                        "put",
                        "/api/v1/promoter/eventRegistrationPrice/levelClass/" + this.itemLevelClassSel.id,
                        data
                    );
                    if (response.success == 1)
                    {
                        this.loadLevelClasses();
                        this.dialogLevelClass = false;
                    } else
                    {
                        if (response.message.data == 'level_exist_for_event')
                        {
                            this.uniqueLevel = true;
                        }
                    }
                }
            }
        },
        async onChangeCostPerson()
        {
            if (this.$refs.formPersonPrice.validate())
            {
                await this.api(
                    "post",
                    "/api/v1/promoter/eventRegistrationPrice/updateOrCreateCostPerson/" + this.$route.params.id,
                    { price: parseFloat(this.costPerson).toFixed(2) }
                );
            }
        },
        customSendAmountP()
        {
            if (this.eventTaxes.type)
            {
                if (this.eventTaxes.type.name == 'fixed')
                {
                    let aux = this.cleanTax();
                    this.eventTaxes.amountPercentage = '$' + aux;
                } else
                {
                    let aux = this.cleanTax();
                    this.eventTaxes.amountPercentage = aux + '%';
                }
            }
        },
        sendMessage(field)
        {
            switch (field)
            {
                case 'country':
                    this.getStatesByCountry();
                    if (this.eventTaxes.country)
                    {
                        this.eventTaxes.state = "";
                        const data = { country: this.eventTaxes.country, state: "" };
                        this.saveEventTaxes(data);
                    }
                    break;
                case 'state':
                    if (this.eventTaxes.state)
                    {
                        const data = { state: this.eventTaxes.state };
                        this.saveEventTaxes(data);
                    }
                    break;
                case 'source':
                    if (this.$refs.inputSource.validate())
                    {
                        const data = { source: this.eventTaxes.source.id };
                        this.saveEventTaxes(data);
                    }
                    break;
                case 'type':
                    if (this.$refs.inputType.validate())
                    {
                        const data = { type: this.eventTaxes.type.id };
                        this.saveEventTaxes(data);
                    }
                    break;
                case 'tax':
                    if (this.$refs.inputTax.validate())
                    {
                        const data = { tax: this.cleanTax() };
                        this.saveEventTaxes(data);
                    }
                    break;
                case 'taxLabel':
                    if (this.$refs.inputTaxLabel.validate())
                    {
                        const data = { taxLabel: this.eventTaxes.taxLabel };
                        this.saveEventTaxes(data);
                    }
                    break;
                case 'taxNumber':
                    if (this.$refs.inputTaxNumber.validate())
                    {
                        const data = { taxNumber: this.eventTaxes.taxNumber };
                        this.saveEventTaxes(data);
                    }
                    break;
            }
        },
        onChangeType()
        {
            this.customSendAmountP();
            this.sendMessage('type');
        },
        onInputTax()
        {
            this.customSendAmountP();
            this.sendMessage('tax');
        },
        cleanTax()
        {
            if (!this.eventTaxes.amountPercentage) {
                return '';
            }
            let aux1 = this.eventTaxes.amountPercentage.replace('%', '');
            let aux = aux1.replace('$', '');
            return aux;
        },
        async loadClassDynamicPrices()
        {
            const response = await this.api(
                'get',
                '/api/v1/promoter/eventRegistrationPrice/classDynamicPrice/' + this.$route.params.id
            );
            if (response && response.success)
            {
                this.classEventDate = response.message.eventDate || null;
                this.classEventTimezone = response.message.timezone || null;
                this.classDaysUntilEvent = Number.isFinite(response.message.daysUntilEvent)
                    ? response.message.daysUntilEvent
                    : null;
                const raw = response.message.data || {};
                // Backend returns either a grouped object {raceClassId: [tiers]} or a flat array
                if (Array.isArray(raw))
                {
                    const grouped = {};
                    raw.forEach((tier) =>
                    {
                        if (!grouped[tier.raceClassId]) grouped[tier.raceClassId] = [];
                        grouped[tier.raceClassId].push(tier);
                    });
                    this.classDynamicPrices = grouped;
                } else
                {
                    this.classDynamicPrices = raw;
                }
            }
        },
        resolveCurrentPrice(classId)
        {
            const tiers = this.classDynamicPrices[classId];
            if (!tiers || tiers.length === 0) return '0.00';
            if (!this.classEventDate) return '0.00';
            const daysUntil = this.getDaysUntilEvent(this.classEventDate);
            const sorted = [...tiers].sort((a, b) => b.daysBeforeEvent - a.daysBeforeEvent);
            const match = sorted.find(t => t.daysBeforeEvent <= daysUntil);
            return match ? parseFloat(match.price).toFixed(2) : '0.00';
        },
        isActiveTier(tier, classId)
        {
            const tiers = this.classDynamicPrices[classId];
            if (!tiers || tiers.length === 0) return false;
            if (!this.classEventDate) {
                const sorted = [...tiers].sort((a, b) => a.daysBeforeEvent - b.daysBeforeEvent);
                return sorted[0] && sorted[0].id === tier.id;
            }
            const daysUntil = this.getDaysUntilEvent(this.classEventDate);
            const sorted = [...tiers].sort((a, b) => b.daysBeforeEvent - a.daysBeforeEvent);
            const match = sorted.find(t => t.daysBeforeEvent <= daysUntil);
            return match && match.id === tier.id;
        },
        getDaysUntilEvent(eventDateValue)
        {
            if (Number.isFinite(this.classDaysUntilEvent))
            {
                return this.classDaysUntilEvent;
            }

            const eventParts = this.parseDateParts(eventDateValue);
            if (!eventParts) return 0;

            const now = new Date();
            const todayUtc = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
            const eventUtc = Date.UTC(eventParts.year, eventParts.month - 1, eventParts.day);
            const diffDays = Math.round((eventUtc - todayUtc) / 86400000);

            return Math.max(0, diffDays);
        },
        parseDateParts(value)
        {
            if (!value) return null;

            const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
            if (match)
            {
                return {
                    year: parseInt(match[1], 10),
                    month: parseInt(match[2], 10),
                    day: parseInt(match[3], 10)
                };
            }

            const parsed = new Date(value);
            if (isNaN(parsed.getTime())) return null;

            return {
                year: parsed.getFullYear(),
                month: parsed.getMonth() + 1,
                day: parsed.getDate()
            };
        },
        sortedTiers(classId)
        {
            const tiers = this.classDynamicPrices[classId] || [];
            return [...tiers].sort((a, b) => b.daysBeforeEvent - a.daysBeforeEvent);
        },
        isClassExpanded(item)
        {
            return this.expandedClasses.some(c => c.id === item.id);
        },
        toggleExpand(item)
        {
            const idx = this.expandedClasses.findIndex(c => c.id === item.id);
            if (idx >= 0)
            {
                this.expandedClasses.splice(idx, 1);
            } else
            {
                this.expandedClasses.push(item);
            }
        },
        openAddTierDialog(classId)
        {
            this.isNewTier = true;
            this.editedDynamicTierId = null;
            this.editedDynamicTier = { raceClassId: classId, daysBeforeEvent: null, price: null };
            this.dynamicPriceDialog = true;
        },
        openEditTierDialog(tier)
        {
            this.isNewTier = false;
            this.editedDynamicTierId = tier.id;
            this.editedDynamicTier = { raceClassId: tier.raceClassId, daysBeforeEvent: tier.daysBeforeEvent, price: tier.price };
            this.dynamicPriceDialog = true;
        },
        closeDynamicTierDialog()
        {
            this.dynamicPriceDialog = false;
            if (this.$refs.formDynamicTier) this.$refs.formDynamicTier.resetValidation();
        },
        async saveClassDynamicPrice()
        {
            if (!this.$refs.formDynamicTier.validate()) return;
            const data = {
                raceClassId: this.editedDynamicTier.raceClassId,
                daysBeforeEvent: parseInt(this.editedDynamicTier.daysBeforeEvent),
                price: parseFloat(this.editedDynamicTier.price).toFixed(2)
            };
            let response;
            if (this.isNewTier)
            {
                response = await this.api(
                    'post',
                    '/api/v1/promoter/eventRegistrationPrice/classDynamicPrice',
                    data
                );
            } else
            {
                response = await this.api(
                    'put',
                    '/api/v1/promoter/eventRegistrationPrice/classDynamicPrice/' + this.editedDynamicTierId,
                    data
                );
            }
            if (response && response.success)
            {
                this.closeDynamicTierDialog();
                this.loadClassDynamicPrices();
            }
        },
        confirmDeleteDynamicTier(tier)
        {
            this.dynamicTierToDelete = tier;
            this.dialogNotificationDynamicTier = true;
        },
        async deleteClassDynamicPrice()
        {
            if (!this.dynamicTierToDelete) return;
            const response = await this.api(
                'delete',
                '/api/v1/promoter/eventRegistrationPrice/classDynamicPrice/' + this.dynamicTierToDelete.id
            );
            if (response && response.success)
            {
                this.loadClassDynamicPrices();
            }
            this.dialogNotificationDynamicTier = false;
            this.dynamicTierToDelete = null;
        }
    },
    created()
    {
        this.loadUser();
        this.loadLanguage();
        this.loadPricing();
        this.loadClasses();
        this.loadCostPerson();
        this.loadLevelClasses();
        this.loadRegFee();
        this.loadInformationLanguage();
        this.loadCountries();
        this.loadSources();
        this.loadTypes();
        this.loadEventTaxes();
        this.loadClassDynamicPrices();
    },
    watch: {
        eventID()
        {
            this.loadUser();
            this.loadLanguage();
            this.loadPricing();
            this.loadClasses();
            this.loadCostPerson();
            this.loadLevelClasses();
            this.loadRegFee();
            this.loadInformationLanguage();
            this.loadCountries();
            this.loadSources();
            this.loadTypes();
            this.loadEventTaxes();
            this.loadClassDynamicPrices();
            if (this.$refs.CouponDiscount)
            {
                this.$refs.CouponDiscount.loadStatusCoupon();
                this.$refs.CouponDiscount.loadTypeCoupon();
                this.$refs.CouponDiscount.loadCoupons();
                this.$refs.CouponDiscount.loadEvents();
            }
        }
    }
}
</script>

<style>
.headTable {
    background: #ccc;
}

.formEventTaxes .v-text-field__details {
    min-height: 0 !important;
    height: auto !important;
    margin-bottom: 0 !important;
    /*border: 1px solid red;*/
}

.formEventTaxes .v-messages {
    min-height: 0 !important;
    height: auto !important;
}

#pricing .v-data-table {
    margin: 0;
}

#pricing .text-start {
    vertical-align: inherit;
}

.d-contents-radio .v-input--radio-group__input {
    display: contents;
}

.mb-label-radio label {
    margin-bottom: 0px;
}

#pricing table thead tr th.sortable:not(.active) .v-icon,
#pricing table thead tr th.sortable:not(.active) .v-icon:hover {
    display: none !important;
}

.active-tier {
    background-color: #e8f5e9 !important;
    font-weight: bold;
}

.dynamic-tier-expanded td {
    background: #f5f5f5;
    padding-top: 10px !important;
    padding-bottom: 6px !important;
}

.dynamic-tier-subheader td {
    background: #fafafa;
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
}

.dynamic-tier-row td {
    background: #fafafa;
}

.dynamic-tier-row:hover td {
    background: #f0f0f0 !important;
}

.class-row {
    cursor: pointer;
}

.class-row:hover {
    background: rgba(0, 0, 0, 0.04);
}

.class-col-expand {
    width: 40px;
    min-width: 40px;
    max-width: 40px;
    padding: 0 4px !important;
}

.class-pricing-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.class-pricing-table table {
    min-width: 500px;
}

.class-pricing-table.v-data-table--mobile > .v-data-table__wrapper > table > tbody {
    display: table-row-group !important;
}
</style>
